import { config } from "./configs";
export const APIURL = config.API_URL;
export const TENANT_KEY = config.TENANT_KEY;
export const MEDIAPATH = config.MEDIAPATH;
export const IMGPATH = config.IMGPATH;
export const currentEventCode = "Common-Job-Application";
export const androidLink = "https://play.google.com/store/apps/details?id=com.masternaukri.app&hl=en_IN";
export const iosLink = "https://apps.apple.com/in/app/masternaukri/id6450824258";